import React from 'react'

import './bookingconfirmed.css'
import { ArrowLeftOutlined } from '@ant-design/icons';

const BookingConfirmed = ({setSearching}) => {
	
	return (
		<div className="bookingconfirmed">
		<div className="backbtn" onClick={() => setSearching(true)}>
			<ArrowLeftOutlined />
		</div>
			RESERVA REALIZADA
			<img src="./check_small.svg" alt="check_icon" />
		</div>
	)
}

export default BookingConfirmed